export const EMPTY_STRING = "";

export const PatternConstant = {
  DATE_FORMAT: 'dd/mm/yy'
};
